import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "d-flex mb-4 align-center" }
const _hoisted_5 = { class: "mr-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "pa-2",
  style: {"background-color":"white"}
}
const _hoisted_8 = { class: "menu-table-row-col-items" }
const _hoisted_9 = { class: "menu-table-row-col col-category" }
const _hoisted_10 = { class: "menu-table-row-col col-menu" }
const _hoisted_11 = { class: "menu-table-row-col col-classes" }
const _hoisted_12 = { class: "menu-table-row-col col-actions" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "my-4" }
const _hoisted_17 = { class: "my-4" }
const _hoisted_18 = {
  key: 0,
  class: "my-4"
}
const _hoisted_19 = { class: "d-flex align-center" }
const _hoisted_20 = { class: "menu-table" }
const _hoisted_21 = { class: "menu-table-headers" }
const _hoisted_22 = { class: "menu-table-header col-date" }
const _hoisted_23 = { class: "menu-table-header col-category" }
const _hoisted_24 = { class: "menu-table-header col-menu" }
const _hoisted_25 = { class: "menu-table-header col-classes" }
const _hoisted_26 = { class: "menu-table-row-col col-date" }
const _hoisted_27 = { class: "d-flex align-center" }
const _hoisted_28 = { class: "date-label" }
const _hoisted_29 = { class: "menu-table-row-col-items" }
const _hoisted_30 = { class: "menu-table-row-col col-category" }
const _hoisted_31 = { class: "menu-table-row-col col-menu" }
const _hoisted_32 = { class: "menu-table-row-col col-classes" }
const _hoisted_33 = { class: "menu-table-row-col col-actions" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_food_menu_create_container = _resolveComponent("food-menu-create-container")!
  const _component_food_menu_test_container = _resolveComponent("food-menu-test-container")!
  const _component_food_menu_edit_container = _resolveComponent("food-menu-edit-container")!
  const _component_food_menu_import_container = _resolveComponent("food-menu-import-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        value: _ctx.$t('foodMenu.title')
      }, null, 8, ["value"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_menu, { "offset-y": "" }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({
            color: "primary",
            variant: "outlined"
          }, props), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-tray-arrow-down", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.download')), 1)
            ]),
            _: 1
          }, 16)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { onClick: _ctx.downloadSample }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.sampleCsv')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_card, {
        class: "pa-4",
        color: "#f0f0f0",
        variant: "flat"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('foodMenu.todayMenu', { date: _ctx.todayLabel })), 1),
            _createVNode(_component_v_btn, {
              variant: "flat",
              color: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCreating(_ctx.todayCode)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
              ]),
              _: 1
            })
          ]),
          (_ctx.todaysMenu && _ctx.todaysMenu.menus.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todaysMenu.menus, (menu, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "menu-table-row-col-item",
                        key: i
                      }, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(menu.category.name), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(menu.body), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatClassNames(menu.category.targetClasses)), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "flat",
                            rounded: "",
                            class: "mx-1",
                            small: "",
                            onClick: ($event: any) => (_ctx.openTestDialog(menu))
                          }, {
                            default: _withCtx(() => [
                              (menu.test)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('foodMenu.inspected')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('foodMenu.inspect')), 1))
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "outlined",
                            rounded: "",
                            class: "mx-1",
                            small: "",
                            onClick: ($event: any) => (_ctx.openEditDialog(menu))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            color: "red",
                            variant: "outlined",
                            rounded: "",
                            class: "mx-1",
                            small: "",
                            onClick: ($event: any) => (_ctx.deleteMenu(menu))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('foodMenu.noMenuToday')), 1))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_month_pager, {
        modelValue: _ctx.yearMonth,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.yearMonth) = $event)),
        onInput: _ctx.pageClick
      }, null, 8, ["modelValue", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        onClick: _ctx.openImportDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.importMenu')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.importStatuses.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_v_card, {
            class: "pa-4",
            color: "#f0f0f0",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('foodMenu.importStatus')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importStatuses, (status, i) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  color: "#fff",
                  class: "my-2 pa-2",
                  variant: "flat",
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", null, _toDisplayString(status.filename), 1),
                      _createVNode(_component_v_spacer),
                      _createElementVNode("div", null, [
                        (status.status === 'inProgress')
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              small: "",
                              color: "orange",
                              variant: "outlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.reading')), 1)
                              ]),
                              _: 1
                            }))
                          : (status.status === 'failed')
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 1,
                                small: "",
                                color: "red",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.readError')), 1)
                                ]),
                                _: 1
                              }))
                            : (status.status === 'success')
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 2,
                                  small: "",
                                  color: "primary",
                                  variant: "outlined"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('foodMenu.readComplete')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 1,
          indeterminate: "",
          class: "my-4",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('foodMenu.date')), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('foodMenu.category')), 1),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('foodMenu.menu')), 1),
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('foodMenu.targetClasses')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "menu-table-header col-actions" }, null, -1))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datesWithMenus, (dwm) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "menu-table-row",
          key: dwm.date
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(dwm.formatted), 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "text",
                size: "small",
                onClick: ($event: any) => (_ctx.setCreating(dwm.date))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" + " + _toDisplayString(_ctx.$t('common.add')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dwm.menus, (menu, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "menu-table-row-col-item",
                key: i
              }, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(menu.category.name), 1),
                _createElementVNode("div", _hoisted_31, _toDisplayString(menu.body), 1),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatClassNames(menu.category.targetClasses)), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    rounded: "",
                    class: "mx-1",
                    small: "",
                    onClick: ($event: any) => (_ctx.openTestDialog(menu))
                  }, {
                    default: _withCtx(() => [
                      (menu.test)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('common_actions.inspected')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('foodMenu.inspect')), 1))
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    rounded: "",
                    class: "mx-1",
                    small: "",
                    onClick: ($event: any) => (_ctx.openEditDialog(menu))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "red",
                    variant: "outlined",
                    rounded: "",
                    class: "mx-1",
                    small: "",
                    onClick: ($event: any) => (_ctx.deleteMenu(menu))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_food_menu_create_container),
    _createVNode(_component_food_menu_test_container, { "onDelete:test": _ctx.listMenus }, null, 8, ["onDelete:test"]),
    _createVNode(_component_food_menu_edit_container),
    _createVNode(_component_food_menu_import_container)
  ]))
}